import useEditableCell from "@/react/components/table/useEditableCell";
import React from "react";
import Input from "@8x8/oxygen-input";
import { cellErrors, KEY } from "@/react/components/table/useTableMutations";

export function PhoneNumberManualCell(phoneCell) {
  const { updateRows, skipAutoResetPageIndex, schema } =
    phoneCell.table.options.meta;
  const errors = cellErrors(phoneCell);
  const { value: phoneValue, onChange: onChangePhone } =
    useEditableCell(phoneCell);

  const onBlur = () => {
    skipAutoResetPageIndex();
    updateRows(
      [phoneCell.row.original[KEY]],
      new Map([
        [schema.fields.phoneNumber.spec.key, phoneValue],
        [schema.fields.didId.spec.key, null],
      ]),
      schema
    );
  };

  return (
    <Input
      size={"small"}
      placeholder="Enter phone number in E.164 format"
      value={phoneValue || ""}
      onChange={(e) => onChangePhone(e.target.value)}
      onBlur={onBlur}
      hasError={errors.length > 0}
      type="tel"
    />
  );
}
